const Contact = () => {
    return (
        <div>
            <h1>Contact</h1>
            <p>Contact page</p>
        </div>
    )
}

export default Contact